import { useEffect, useState } from "react";
import NotFound from "./notfound";

// Route changes right after signing in or picking a restaurant briefly hit
// this wildcard before the redirect effects in App.js catch up (they run in
// an effect, one tick after the route tree re-renders with the newly
// allowed routes). Waiting a beat before actually showing the 404 avoids
// flashing it during that transition; a real bad URL still ends up here.
const DelayedNotFound = () => {
  const [showNotFound, setShowNotFound] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowNotFound(true), 250);
    return () => clearTimeout(timer);
  }, []);

  return showNotFound ? <NotFound /> : null;
};

export default DelayedNotFound;
